export default __webpack_public_path__ + "static/media/BrandonGrotesque-Medium.176d019b.woff2";